import { IconTimes } from '../icon/icon'
import { SEARCH_FIELD_PROPS } from '../component/search-field-props'

export const TextFilter = ({ value, onChange }) => {
  const handleChange = e => onChange && onChange(e.target.value)
  const handleClear = () => onChange && onChange('')

  return (
    <div className="input-group">
      <input {...SEARCH_FIELD_PROPS} name="permission-filter" aria-label="search" className="form-control search-own-clear" placeholder="search" value={value} onChange={handleChange} />
      <span className="input-group-text" onClick={handleClear}>
        <IconTimes />
      </span>
    </div>
  )
}
